import React, { useCallback, useEffect } from "react";
import { Portal, Button } from "@/components";
import closeIcon from "@/assets/icons/closeIcon.svg";
import styles from "./CancelRequestModal.module.scss";

interface CancelRequestModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>> | ((value: boolean) => void);
  onConfirm: () => void;
  isLoading?: boolean;
  isTournament?: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  loadingText?: string;
}

export const CancelRequestModal: React.FC<CancelRequestModalProps> = ({
  isOpen,
  setIsOpen,
  onConfirm,
  isLoading = false,
  isTournament = false,
  title,
  message,
  confirmText,
  loadingText,
}) => {
  const handleClose = useCallback(() => {
    if (!isLoading) {
      setIsOpen(false);
    }
  }, [isLoading, setIsOpen]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") handleClose();
    };
    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
      document.body.style.overflow = "hidden";
    }
    return () => {
      window.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "visible";
    };
  }, [isOpen, handleClose]);

  if (!isOpen) return null;

  return (
    <Portal>
      <div className={styles.overlay} onClick={handleClose}>
        <div className={styles.card} onClick={(e) => e.stopPropagation()}>
          <div className={styles.header}>
            <span className={styles.title}>
              {title
                ? title
                : isTournament
                  ? "Уверены, что хотите отменить регистрацию?"
                  : "Уверены, что хотите отменить заявку?"}
            </span>
            <button className={styles.closeButton} onClick={handleClose}>
              <img src={closeIcon} alt="close" />
            </button>
          </div>
          <Button
            onClickFunc={onConfirm}
            disabled={isLoading}
            newStyles={styles.confirmButton}
          >
            {isLoading
              ? (loadingText || "Отмена...")
              : (confirmText || "Отменить")}
          </Button>
        </div>
      </div>
    </Portal>
  );
};
